import { useEffect, useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import Alert from '@/components/common/Alert';
import { onVersionUpdate, reloadForNewVersion } from '@/utils/versionCheck';

/**
 * Banner component that displays when a new version of the application is available.
 * Subscribes to version update events from the Apollo client's version checking.
 * Provides a clickable refresh link to reload the page with the new version.
 */
const VersionUpdateBanner = () => {
    useTranslation('common');
    const [hasNewVersion, setHasNewVersion] = useState(false);

    useEffect(() => {
        const unsubscribe = onVersionUpdate(() => {
            setHasNewVersion(true);
        });

        return unsubscribe;
    }, []);

    if (!hasNewVersion) {
        return null;
    }

    return (
        <Alert
            color="primary"
            variant="soft"
            className="mb-6"
            description={
                <Trans
                    components={{
                        action: (
                            <button
                                type="button"
                                onClick={reloadForNewVersion}
                                className="cursor-pointer font-bold underline"
                            />
                        ),
                    }}
                    i18nKey="common:versionUpdate.message"
                />
            }
        />
    );
};

export default VersionUpdateBanner;
